import { memo, useState } from 'react';
import { parseCards, cardSrc } from './cards/cardUtils';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function PieChartSvg({ pPct, bPct, tPct, w, h, cx, cy, rx, ry, dep, fs }) {
  const rad = (pct) => (pct / 100) * 2 * Math.PI;
  const start = -Math.PI / 2;
  const a1 = start + rad(pPct);
  const a2 = a1 + rad(bPct);
  const px2 = (a) => cx + rx * Math.cos(a);
  const py2 = (a) => cy + ry * Math.sin(a);
  const pEnd = [px2(a1), py2(a1)];
  const bEnd = [px2(a2), py2(a2)];
  const tf = 0.65;
  const txtPos = (aS, aE) => {
    const mid = (aS + aE) / 2;
    return [cx + rx * tf * Math.cos(mid), cy + ry * tf * Math.sin(mid)];
  };
  const [pTx, pTy] = txtPos(start, a1);
  const [bTx, bTy] = txtPos(a1, a2);
  const [tTx, tTy] = txtPos(a2, start + 2 * Math.PI);
  const lx = w - (w === 406 ? 136 : 61);

  return (
    <div>
      <div style={{ position: 'relative' }}>
        <div dir="ltr" style={{ position: 'relative', width: w, height: h }}>
          <div aria-label="A chart." style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}>
            <svg width={w} height={h} aria-label="A chart." style={{ overflow: 'hidden' }}>
              <defs />
              <g>
                <rect x={lx} y="3" width={w-lx} height="42" stroke="none" strokeWidth="0" fillOpacity="0" fill="#ffffff" />
                <g><rect x={lx} y="3" width={w-lx} height={fs+1} stroke="none" strokeWidth="0" fillOpacity="0" fill="#ffffff" /><g><text textAnchor="start" x={lx+14} y={3+fs*0.85} fontFamily="Arial" fontSize={fs} stroke="none" strokeWidth="0" fill="#222222">Player</text></g><circle cx={lx+5} cy={3+(fs+1)/2} r={fs/2} stroke="none" strokeWidth="0" fill="#086cb8" /></g>
                <g><rect x={lx} y={3+fs+3} width={w-lx} height={fs+1} stroke="none" strokeWidth="0" fillOpacity="0" fill="#ffffff" /><g><text textAnchor="start" x={lx+14} y={3+fs+3+fs*0.85} fontFamily="Arial" fontSize={fs} stroke="none" strokeWidth="0" fill="#222222">Banker</text></g><circle cx={lx+5} cy={3+fs+3+(fs+1)/2} r={fs/2} stroke="none" strokeWidth="0" fill="#ae2130" /></g>
                <g><rect x={lx} y={3+2*(fs+3)} width={w-lx} height={fs+1} stroke="none" strokeWidth="0" fillOpacity="0" fill="#ffffff" /><g><text textAnchor="start" x={lx+14} y={3+2*(fs+3)+fs*0.85} fontFamily="Arial" fontSize={fs} stroke="none" strokeWidth="0" fill="#222222">Tie</text></g><circle cx={lx+5} cy={3+2*(fs+3)+(fs+1)/2} r={fs/2} stroke="none" strokeWidth="0" fill="#279532" /></g>
              </g>
              <g>
                <path d={`M${cx+rx},${cy}L${cx+rx},${cy+dep}A${rx},${ry},0,0,1,${pEnd[0]},${pEnd[1]+dep}L${pEnd[0]},${pEnd[1]}A${rx},${ry},0,0,0,${cx+rx},${cy}`} stroke="#06518a" strokeWidth="1" fill="#06518a" />
                <path d={`M${cx},${cy}L${cx},${cy+dep}L${pEnd[0]},${pEnd[1]+dep}L${pEnd[0]},${pEnd[1]}`} stroke="#06518a" strokeWidth="1" fill="#06518a" />
                <path d={`M${cx},${cy}L${cx},${cy-ry}A${rx},${ry},0,${pPct>50?1:0},1,${pEnd[0]},${pEnd[1]}L${cx},${cy}A0,0,0,0,0,${cx},${cy}`} stroke="#086cb8" strokeWidth="1" fill="#086cb8" />
                <text textAnchor="start" x={pTx-8} y={pTy+3} fontFamily="Arial" fontSize={fs} stroke="none" strokeWidth="0" fill="#ffffff">{pPct}%</text>
              </g>
              <g>
                <path d={`M${cx},${cy}L${cx},${cy+dep}L${bEnd[0]},${bEnd[1]+dep}L${bEnd[0]},${bEnd[1]}`} stroke="#1d7026" strokeWidth="1" fill="#1d7026" />
                <path d={`M${cx},${cy}L${bEnd[0]},${bEnd[1]}A${rx},${ry},0,${tPct>50?1:0},1,${cx},${cy-ry}L${cx},${cy}A0,0,0,0,0,${cx},${cy}`} stroke="#279532" strokeWidth="1" fill="#279532" />
                {tPct > 5 && <text textAnchor="start" x={tTx-8} y={tTy+3} fontFamily="Arial" fontSize={fs} stroke="none" strokeWidth="0" fill="#ffffff">{tPct}%</text>}
              </g>
              <g>
                <path d={`M${pEnd[0]},${pEnd[1]}L${pEnd[0]},${pEnd[1]+dep}A${rx},${ry},0,0,1,${cx-rx},${cy+dep}L${cx-rx},${cy}A${rx},${ry},0,0,0,${pEnd[0]},${pEnd[1]}`} stroke="#831924" strokeWidth="1" fill="#831924" />
                <path d={`M${cx},${cy}L${pEnd[0]},${pEnd[1]}A${rx},${ry},0,${bPct>50?1:0},1,${bEnd[0]},${bEnd[1]}L${cx},${cy}A0,0,0,0,0,${cx},${cy}`} stroke="#ae2130" strokeWidth="1" fill="#ae2130" />
                <text textAnchor="start" x={bTx-8} y={bTy+3} fontFamily="Arial" fontSize={fs} stroke="none" strokeWidth="0" fill="#ffffff">{bPct}%</text>
              </g>
              <g />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

function BaccaratPieChart({ p, b, t }) {
  const total = p + b + t || 1;
  const pPct = Math.round((p / total) * 100);
  const bPct = Math.round((b / total) * 100);
  const tPct = 100 - pPct - bPct;

  return (
    <>
      <div className="d-none-mobile">
        <PieChartSvg pPct={pPct} bPct={bPct} tPct={tPct} w={202} h={160} cx={65} cy={73.9} rx={61} ry={48.8} dep={12.2} fs={9} />
      </div>
      <div className="d-none-desktop">
        <PieChartSvg pPct={pPct} bPct={bPct} tPct={tPct} w={406} h={160} cx={131} cy={72.3} rx={77} ry={61.6} dep={15.4} fs={10} />
      </div>
    </>
  );
}

function fmtAmt(n) {
  const x = Number(n) || 0;
  if (x >= 100000) return `${x / 100000}L`;
  if (x >= 1000) return `${x / 1000}K`;
  return String(x);
}

function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}

function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// casino-min-max range collapse; iFloat => i.float-right (odds blocks)
function MinMax({ rangeId, min, max, iFloat }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="casino-min-max">
      <i
        data-toggle="collapse"
        data-target={`#${rangeId}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`fas fa-info-circle${iFloat ? ' float-right' : ''}${open ? '' : ' collapsed'}`}
        onClick={() => setOpen((o) => !o)}
      ></i>
      {' '}
      <div id={rangeId} className={`collapse icon-range${open ? ' show' : ''}`}>
        {'\n                      R:'}
        <span>{fmtAmt(min ?? 100)}</span>
        -
        <span>{fmtAmt(max ?? 0)}</span>
      </div>
    </div>
  );
}

const BetTableBaccarat2 = memo(function BetTableBaccarat2({ gameData, onBet, stats, exposures }) {
  const [statsOpen, setStatsOpen] = useState(true);
  const sub = gameData?.sub ?? [];

  const getBySid = (sid) => sub.find((s) => s.sid === sid) || {};

  const scores = [
    { item: getBySid(6),  name: 'Score 1-4', range: 'range1' },
    { item: getBySid(7),  name: 'Score 5-6', range: 'range2' },
    { item: getBySid(8),  name: 'Score 7',   range: 'range3' },
    { item: getBySid(9),  name: 'Score 8',   range: 'range4' },
    { item: getBySid(10), name: 'Score 9',   range: 'range10' },
  ];
  const playerPair = getBySid(4);
  const player     = getBySid(1);
  const tie        = getBySid(3);
  const banker     = getBySid(2);
  const bankerPair = getBySid(5);

  const isSuspended = (item) => item?.gstatus === 'SUSPENDED' || item?.gstatus === '0';

  const cards = parseCards(gameData?.card ?? '');
  const playerCards = [cards[2], cards[0]].filter(Boolean);
  const playerCard3 = cards[4] || null;
  const bankerCards = [cards[1], cards[3]].filter(Boolean);
  const bankerCard3 = cards[5] || null;

  const oddBlock = ({ item, name, range }) => {
    const book = bookOf(exposures, name, item?.sid);
    return (
      <div
        key={name}
        className="baccarat-odd-block"
        onClick={() => !isSuspended(item) && onBet && onBet(item.sid, 'back', item.b, item)}
        role="button"
      >
        <div className={`baccarat-odd-name${isSuspended(item) ? ' suspended' : ''}`}>{name} {item.b ?? 0}:1</div>
        {' '}
        <div className={`baccarat-odd-val ${bookCls(book)}`}>{fmtBook(book)}</div>
        {' '}
        <MinMax rangeId={range} min={item?.min} max={item?.max ?? 100000} iFloat />
      </div>
    );
  };

  return (
    <>
    <div className="baccarat-bets-odds pt-3">
      <div className="baccarat-odds">
        {scores.map(oddBlock)}
      </div>

      <div className="baccarat-bets">
        <div
          className="player-pair"
          onClick={() => !isSuspended(playerPair) && onBet && onBet(playerPair.sid, 'back', playerPair.b, playerPair)}
          role="button"
        >
          <div className={`baccarat-bets-name${isSuspended(playerPair) ? ' suspended' : ''}`}>
            <div>Player Pair</div>
            {' '}
            <div className="mb-0">{playerPair.b ?? 0}:1</div>
          </div>
          {' '}
          <div className={`baccarat-bets-val ${bookCls(bookOf(exposures, 'Player Pair', playerPair?.sid))}`}>{fmtBook(bookOf(exposures, 'Player Pair', playerPair?.sid))}</div>
          {' '}
          <MinMax rangeId="range5" min={playerPair?.min} max={playerPair?.max ?? 100000} />
        </div>

        <div
          className="player"
          onClick={() => !isSuspended(player) && onBet && onBet(player.sid, 'back', player.b, player)}
          role="button"
        >
          <div className={`baccarat-bets-name${isSuspended(player) ? ' suspended' : ''}`}>
            <div>Player {player.b ?? 0}:1</div>
            {' '}
            <div className="mb-0">
              {playerCard3 && playerCard3 !== '1'
                ? <span className="l-rotate" data-v-b64efdfa=""><img data-v-b64efdfa="" src={cardSrc(playerCard3)} /></span>
                : null}
              {' '}
              {playerCards.map((c, i) => (
                <span key={i} data-v-b64efdfa=""><img data-v-b64efdfa="" src={cardSrc(c)} /></span>
              ))}
            </div>
          </div>
          {' '}
          <div className={`baccarat-bets-val ${bookCls(bookOf(exposures, 'Player', player?.sid))}`}>{fmtBook(bookOf(exposures, 'Player', player?.sid))}</div>
          {' '}
          <MinMax rangeId="range6" min={player?.min} max={player?.max ?? 100000} />
        </div>

        <div
          className="tie"
          onClick={() => !isSuspended(tie) && onBet && onBet(tie.sid, 'back', tie.b, tie)}
          role="button"
        >
          <div className={`baccarat-bets-name${isSuspended(tie) ? ' suspended' : ''}`}>
            <div>Tie</div>
            {' '}
            <div className="mb-0">{tie.b ?? 0}:1</div>
          </div>
          {' '}
          <div className={`baccarat-bets-val ${bookCls(bookOf(exposures, 'Tie', tie?.sid))}`}>{fmtBook(bookOf(exposures, 'Tie', tie?.sid))}</div>
          {' '}
          <MinMax rangeId="range7" min={tie?.min} max={tie?.max ?? 100000} />
        </div>

        <div
          className="banker"
          onClick={() => !isSuspended(banker) && onBet && onBet(banker.sid, 'back', banker.b, banker)}
          role="button"
        >
          <div className={`baccarat-bets-name${isSuspended(banker) ? ' suspended' : ''}`}>
            <div>Banker {banker.b ?? 0}:1</div>
            {' '}
            <div className="mb-0">
              {bankerCards.map((c, i) => (
                <span key={i} data-v-b64efdfa=""><img data-v-b64efdfa="" src={cardSrc(c)} /></span>
              ))}
              {' '}
              {bankerCard3 && bankerCard3 !== '1'
                ? <span className="r-rotate" data-v-b64efdfa=""><img data-v-b64efdfa="" src={cardSrc(bankerCard3)} /></span>
                : null}
            </div>
          </div>
          {' '}
          <div className={`baccarat-bets-val ${bookCls(bookOf(exposures, 'Banker', banker?.sid))}`}>{fmtBook(bookOf(exposures, 'Banker', banker?.sid))}</div>
          {' '}
          <MinMax rangeId="range8" min={banker?.min} max={banker?.max ?? 100000} />
        </div>

        <div
          className="banker-pair"
          onClick={() => !isSuspended(bankerPair) && onBet && onBet(bankerPair.sid, 'back', bankerPair.b, bankerPair)}
          role="button"
        >
          <div className={`baccarat-bets-name${isSuspended(bankerPair) ? ' suspended' : ''}`}>
            <div>Banker Pair</div>
            {' '}
            <div className="mb-0">{bankerPair.b ?? 0}:1</div>
          </div>
          {' '}
          <div className={`baccarat-bets-val ${bookCls(bookOf(exposures, 'Banker Pair', bankerPair?.sid))}`}>{fmtBook(bookOf(exposures, 'Banker Pair', bankerPair?.sid))}</div>
          {' '}
          <MinMax rangeId="range9" min={bankerPair?.min} max={bankerPair?.max ?? 100000} />
        </div>
      </div>
    </div>

    {stats && (
      <div className="statistics">
        <div className="statistics-title" onClick={() => setStatsOpen((v) => !v)} style={{ cursor: 'pointer' }}>
          Statistics
          <span><i className={`fas fa-angle-${statsOpen ? 'up' : 'down'}`}></i></span>
        </div>
        <div className="statistics-conten1t" style={statsOpen ? {} : { display: 'none' }}>
          <BaccaratPieChart p={parseFloat(stats.p) || 0} b={parseFloat(stats.b) || 0} t={parseFloat(stats.t) || 0} />
        </div>
      </div>
    )}
    </>
  );
});

export default BetTableBaccarat2;
